module.exports = __webpack_public_path__ + "static/media/Cassie-realEstate_160px.ee9d3b63.jpg";